import { render, staticRenderFns } from "./myMark.vue?vue&type=template&id=4070dde2&scoped=true&"
import script from "./myMark.vue?vue&type=script&lang=js&"
export * from "./myMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4070dde2",
  null
  
)

export default component.exports